// extracted by mini-css-extract-plugin
export default {"root":"LibraryPage_root__mDVNv","header":"LibraryPage_header__Fs1q7","body":"LibraryPage_body__ay-Dl"};